import { buildQV, freshenUp } from '../modals_2017/_buildQV';
import Cookies from 'js-cookie';
import { flatSizeMobileQVPrice } from '../productDisplay/_flatSizeMobileQVPrice';
import { quickConvert } from '../international/_intl';

//built on page load on buildqv
const buildMainSkuObj = (skus) => {
	const mainSku = {};
	Object.values(skus).map((val, index) => {
		const catentryId = val.catentryId;
		const fullImageName = val.fullImage;
		const fullThumbNail = val.thumbnail;
		const listPrice = val.offer.price;
		val.definingAttributes.map((attr) => {
			const name = attr.name;
			const displayStyle = attr.displayStyle;
			const attrSeq = attr.sequence;
			const value = attr.value.value;
			const defaultSelected = attr.defaultSelected;
			if (mainSku[catentryId]) {
				mainSku[catentryId].values = [...(mainSku[catentryId].values || []), { name, value, displayStyle, attrSeq, defaultSelected }];
			} else {
				mainSku[catentryId] = { catentryId, attrSeq, fullImageName, fullThumbNail, listPrice };
				mainSku[catentryId].values = [{ name, value, displayStyle, attrSeq, defaultSelected }];
			}
		})
	})
	return mainSku;
}

const buildSearchSkuObj = () => {
	let getDivSKUS = JSON.parse(document.getElementById('allSkus').innerText);
	let attrsVals = {};
	getDivSKUS?.map((sku, index) => {
		const catentryId = sku.catentryId;
		const fullImageName = sku.fullImage;
		const fullThumbNail = sku.thumbnail;
		const listPrice = sku.offer.price;
		sku.definingAttributes.map((attr) => {
			const name = attr.name
			const value = attr.value.value
			if (attrsVals[catentryId]) {
				attrsVals[catentryId].values = [...(attrsVals[catentryId].values || []), { name, value }]
			} else {
				attrsVals[catentryId] = { catentryId, fullImageName, fullThumbNail }
				attrsVals[catentryId].values = [{ name, value }];
			}
		})
	})
	return attrsVals;
}

//built on page load on buildqv to determine if dropdown or flat
const getAttrDisplayStyle = (skusObj) => {
	const attrDispStyObj = {};
	Object.keys(skusObj).forEach((catID => {
		skusObj[catID].values.map((val => {
			let attrName = val.name;
			let attrDisplayStyle = val.displayStyle;
			let sequence = val.attrSeq;
			let defaultSelected = val.defaultSelected;
			if (!attrDispStyObj[attrName]) {
				attrDispStyObj[attrName] = { attrName, attrDisplayStyle, sequence, defaultSelected };
			}
		}))
	}))
	return Object.fromEntries(Object.entries(attrDispStyObj).sort((a, b) => a[1].sequence - b[1].sequence));
}

//built on page load on buildqv to get all attribute values for each sku
const getAttrValues = (skusObj) => {
	const attrMain = {};
	Object.values(skusObj.skus).map((val, index) => {
		Object.values(val.definingAttributes).map((vals => {
			const name = vals.name;
			const value = vals.value.value;
			const attrValSequence = vals.value.sequence;
			const displayStyle = vals.displayStyle;
			const defaultSelected = vals.defaultSelected;
			const sequence = vals.sequence;
			if (attrMain[name]) {
				if (!attrMain[name].values.some(existingValue => existingValue.value === value)) {
					attrMain[name].values.push({ value, sequence: attrValSequence })
				}
			} else {
				attrMain[name] = { name, sequence, displayStyle, defaultSelected }
				attrMain[name].values = [{ value, sequence: attrValSequence }];
			}
		}))
	})
	Object.values(attrMain).map(attr => attr.values.sort((a, b) => a.sequence - b.sequence == 0 ? a.value.localeCompare(b.value) : a.sequence - b.sequence))
	return attrMain;
};

//built on page load - if product has 1 attribute, we need oneAttrPricing functions
function getAttrLength(skus) {
	let attrLength;
	Object.values(skus).map((attr => {
		attrLength = attr.definingAttributes.length;
	}))
	return attrLength;
};

//One Attribute, oneOption and Item pages Functions
function oneAttrPageLoad() {
	getOneAttrPricing();
};

function itemPageLoad() {
	let priceObj = buildPriceObj();
	addPrice('Item', priceObj);
};

function oneOptPageLoad(oneOptAttr, hasItem) {
	let priceObj = buildPriceObj();
	addPrice(oneOptAttr, priceObj, 'oneOpt', hasItem);
};

function getOneAttrPricing() {
	const divSkus = JSON.parse(document.getElementById('allSkus').innerText);
	let oneAttrSamePrice = true;
	let curPrice, testPrice;

	//Check if all the prices are the same
	Object.values(divSkus).map((price => {
		curPrice = price.offer.price;
		if(!testPrice) {
			testPrice = curPrice;
		}
		if(curPrice != testPrice) {
			oneAttrSamePrice = false;
		}
	}))
	//show price if they are different
	if(!oneAttrSamePrice) {
		getOneAttrPrice(divSkus);
	}
}

function getOneAttrPrice(allSkus) {
	const curAttrState = getAttrState();
	let isOneSize, otherAttr;
	//check if it's a one size attr
	Object.keys(curAttrState).map((attr => {
		if(attr === 'Size') {
			if(curAttrState[attr].selectedValue === 'One Size') {
				isOneSize = true;
			} 
		} else {
			otherAttr = attr;
		}
	}))
	let curPriceVals = [];
	let price, attrName, attrVal, attrStr;
	if(isOneSize) {
		Object.values(allSkus).forEach((sku => {
			price = sku.offer.price;
			sku.definingAttributes.map((attr => {
				if(attr.name === otherAttr) {
					attrName = attr.name;
					attrVal = attr.value.value;
					attrStr = { attrName, attrVal, price };
					curPriceVals.push(attrStr);
				}
			}))
		}))
	} else {
		Object.values(allSkus).forEach((sku => {
			price = sku.offer.price;
			attrName = sku.definingAttributes[0].name;
			attrVal = sku.definingAttributes[0].value.value;
			attrStr = { attrName, attrVal, price };
			curPriceVals.push(attrStr);
		}))
	}
	let allAttrsSelected = haveAllAttrsSelected();
	if(isOneSize && allAttrsSelected && $('.mobilePage').length > 0) {
		let findSelected = Object.values(curAttrState).filter((val => val.attrName !== 'Size'));
		let curSelected = findSelected[0].selectedValue;
		let findPrice = curPriceVals.filter((val => val.attrVal === curSelected));
		let curPrice = findPrice[0].price;
		flatSizeMobileQVPrice(curPrice);
	} else {
		addOneAttrPrice(curPriceVals);
	}
};

function addOneAttrPrice(curPriceVals) {
	const zonosIsWorking = typeof zonos === 'object' ? true : false;
	let attrName = curPriceVals[0].attrName.replace(' ', '').toLowerCase();
	let priceParentEle = '[data-attrname='+ attrName +']';
	let priceAttrVals = document.querySelectorAll(priceParentEle);
	priceAttrVals.forEach((val => {
		let curOptVal = val.getAttribute('data-attrvalue');
		let hasOneOption = val.classList.contains('one-option');
		let curIsUnavailable = val.classList.contains('unavailable');
		//for gift cards
		let cleanPrice = curOptVal.replace('$', '');
		curPriceVals.map((price, j) => {
			let curPrice = price.price;
			if (price.attrVal === cleanPrice && !hasOneOption && !curIsUnavailable) {
				let priceStr = curPrice.toFixed(2);
				let curPriceStr = zonosIsWorking ? zonos.currencyConvertAndFormat(priceStr) : '$' + priceStr;
				let curVal = val.innerHTML;
				if (!curVal.includes('-')) {
					val.innerHTML = curVal + ' - ' + curPriceStr;
				}
			}
		})
	}))
};

//All images for alt clicks (Color and Initial Only)
const getAllImages = (value) => {
	let mainSku = buildMainSkuObj(value);
	let allImages = [];
	let imgArr = [];
	Object.values(mainSku).map((val => {
		let allValues = val.values;
		let imgName = val.fullImageName;
		let imgThumbnail = val.fullThumbNail;
		allValues.map((val => {
			let attrName = val.name;
			let attrValue = val.value;
			if(attrName === 'Color' || attrName === 'Initial')
				imgArr = {attrName, attrValue, imgName, imgThumbnail};
				allImages.push(imgArr);
		}))
	}))
	allImages = Array.from(new Set(allImages));
	return allImages;
};

function altClickImages(e) {
	const divSkus = JSON.parse(document.getElementById('allSkus').innerText);
	let isOneAttr = getAttrLength(divSkus);
	let allImages = getAllImages(divSkus);
	let isOneSize, otherAttr;
	//check if it's a one size attr
	const curAttrState = getAttrState();
	Object.keys(curAttrState).map((attr => {
		if(attr === 'Size') {
			if(curAttrState[attr].selectedValue === 'One Size') {
				isOneSize = true;
			} 
		} else {
			otherAttr = attr;
		}
	}))
	let imgName = e.target.getAttribute('data-fullimage').split('_ai')[0]?.split('__')[0];
	let attrSelector, imgAttrName, imgAttrVal;

	//find the attr and value if the image name matches a sku
	Object.values(allImages).map((img => {	
		if(img.imgName === imgName) {
			imgAttrName = img.attrName.toLowerCase();
			imgAttrVal = img.attrValue;
			addSelectedClass(img.attrName, img.attrValue);
			if(isOneAttr === 1 || isOneSize) {
				let attrName = img.attrName;
				if(isOneSize) { attrName = otherAttr};
				dropDownOneAttrChange(attrName, img.attrValue);
			} else {
				dropDownAttrChange(img.attrName, img.attrValue);
			}
		}
	}))

	//if attribute is a dropdown, buttons are taken care of by the addSelectedClass function
	attrSelector = document.querySelector('.' + imgAttrName + '-select');
	if(attrSelector !== null) {
		attrSelector.value = imgAttrVal;
	}

	//if attr is color and not on mobile, we need to deal with the swatches
	if($('.desktopPage').length > 0 || $('.tabletPage').length > 0) {
		if(imgAttrName === 'color') {

			//Remove any selected swatches
			let swatchSelRemove = document.querySelector('img.swatchImage.swatch-selected');
			if(swatchSelRemove) {
				swatchSelRemove.classList.remove('swatch-selected');
			}
			
			//Add selected class to color imgAttrVal, get the index of that swatch for slick swatches carousel
			let imgAttrVal_noSpace = imgAttrVal.replaceAll(' ', '');
			imgAttrVal_noSpace = imgAttrVal_noSpace.replace(/[^a-z0-9]/gi, '');
			let swatchSelAdd = document.querySelector('img.swatchImage[data-selector=' + imgAttrVal_noSpace + ']')
			if(swatchSelAdd) {
				swatchSelAdd.classList.add('swatch-selected');
				let getSwatchIndex = document.querySelector('.swatchListItem[data-selector=' + imgAttrVal_noSpace + ']').getAttribute('data-slick-index');
				$('.swatchList').slick('slickGoTo', getSwatchIndex);
			}
		}
	}
	//Did the alt Image have a value that's not available?
	checkInvalidCombo();
};

//called from altClickImages, if a value that's been selected by an alt click has an unavailable class, 
//add has-error and invalidSelection class, formValidation handles the message of invalid Combo
function checkInvalidCombo() {
	let formGroup = document.querySelectorAll('.form-group.form-attr');
	formGroup = Array.from(formGroup);
	formGroup.forEach((form) => {
		let thisFormSelect = form.querySelector('.qvAttr');
		let invalidSelection = thisFormSelect.querySelector('.unavailable.selected');
		if (invalidSelection !== null) {
			form.classList.add('invalidSelection', 'has-error');
		} else {
			form.classList.remove('invalidSelection', 'has-error');
		}
	});
};

function removeInvalidCombo() {
	let formGroup = document.querySelectorAll('.form-group.form-attr');
	formGroup = Array.from(formGroup);
	formGroup.forEach((form) => {
		form.classList.remove('invalidSelection', 'has-error');		
	});
}

//Called from dropDownAttrChange and buttonAttrChange to handle all selected classes
function addSelectedClass(selectedAttrName, selectedAttrVal) {
	let parentEle = selectedAttrName.replaceAll(' ', '').toLowerCase();
	let optVals = document.querySelectorAll('[data-attrname=' + parentEle + ']');
	optVals = Array.from(optVals);
	optVals.forEach((val => {	
		let attrVal = val.getAttribute('data-attrvalue');
		let isOneOption = val.classList.contains('one-option');
		val.classList.remove('selected', 'size-selected');
		if (attrVal === selectedAttrVal && !isOneOption) {
			val.classList.add('selected', 'size-selected');			
		}
	}))
};

//Handles change event on buildQV and called when there's just 1 attribute and a dropdown
function dropDownOneAttrChange(selectedAttrName, selectedAttrVal) {
	addSelectedClass(selectedAttrName, selectedAttrVal);
	getOneAttrPricing(selectedAttrName, selectedAttrVal);
}

//Handles change event on buildQV and called when there's just 1 attribute and a button
function buttonOneAttrChange(selectedAttrName, selectedAttrVal) {
	//if the button has a price, remove it for comparison
	selectedAttrVal = selectedAttrVal.split('-');
	selectedAttrVal = selectedAttrVal[0].trim();
	addSelectedClass(selectedAttrName, selectedAttrVal);
	getOneAttrPricing(selectedAttrName, selectedAttrVal);
}

//This function mimics a State in React - every time it's called in any function, it returns all selected values
const getAttrState = () => {
	const divSkus = JSON.parse(document.getElementById('allSkus').innerText);
	const allSKUs = buildMainSkuObj(divSkus);
	const origAttrState = {};
	Object.values(allSKUs).map((skus => {
		Object.values(skus.values).map((val => {
			let attrName = val.name;
			let selectedValue;
			if (!origAttrState[attrName]) {
				origAttrState[attrName] = { attrName, selectedValue };
			}
		}))
	}))
	let attrState = origAttrState;
	// check for one-option selected values
	let oneOpts = document.querySelectorAll('.one-option');
	oneOpts = Array.from(oneOpts);
	oneOpts.forEach((oneOpt => {
		let attrName = oneOpt.getAttribute('data-orig');
		let selVal = oneOpt.getAttribute('data-attrvalue');
		attrState[attrName].selectedValue = selVal;
	}))
	//get all selected values of dropdowns
	let selectParent = document.querySelectorAll('select.form-control option');
	selectParent = Array.from(selectParent)
	selectParent.forEach((opt => {
		if (opt.classList.contains('size-selected')) {
			let attrNameSel = opt.getAttribute('data-orig');
			let selectedValue = opt.getAttribute('data-attrvalue');
			Object.keys(attrState).forEach((attrName => {
				if (attrNameSel === attrName) {
					attrState[attrNameSel].selectedValue = selectedValue;
				}
			}))
		}
	}))
	//get all selected values of buttons
	let flatParents = document.querySelectorAll('.form-control.flat li');
	flatParents.forEach((item => {
		if (item.classList.contains('size-selected')) {
			let attrNameFlatSel = item.getAttribute('data-orig');
			let selectedFlatValue = item.getAttribute('data-attrvalue');
			Object.keys(attrState).forEach((attrName => {
				if (attrNameFlatSel === attrName) {
					attrState[attrNameFlatSel].selectedValue = selectedFlatValue;
				}
			}))
		}
	}))
	return attrState;
}

function getAvailableSkus(attrName, selectedAttrName, isOneOpt) {
	let curAttrState = getAttrState();
	let availableValues = [];
	let getAllSkus = buildSearchSkuObj();
	let otherSelectedAttributes = Object.values(curAttrState).filter((selectedAttr => {
		return selectedAttr.attrName !== attrName && selectedAttr.selectedValue;
	}))
	let skusWithAllValues = [];
	Object.values(getAllSkus).map((sku => {
		let containsAllValues = true;
		sku.values.map((vals => {
			otherSelectedAttributes.map((selectedAttr => {
				if (vals.name === selectedAttr.attrName && vals.value !== selectedAttr.selectedValue) {
					containsAllValues = false;
				}
			}))
		}))
		if (containsAllValues) {
			skusWithAllValues.push(sku);
		}
	}))
	skusWithAllValues.map((sku => {
		sku.values.map((attr => {
			if (attr.name === attrName) {
				availableValues.push(attr.value);
			}
		}))
	}))
	availableValues = Array.from(new Set(availableValues));
	const priceObj = buildPriceObj();
	if ($('.mobilePage').length === 0) {
		clearPrice(attrName);
	}
	changeAvailability(availableValues, attrName, priceObj, selectedAttrName, isOneOpt);
}

function changeAvailability(availableValues, attrName, priceObj, selectedAttrName, isOneOpt) {
	let attrNameForEle = attrName.replace(' ', '').toLowerCase();
	let eleVals = document.querySelectorAll('[data-attrname=' + attrNameForEle + ']');
	removeInvalidCombo();
	eleVals.forEach((val => {
		//get button or dropdown
		let eleType = val.tagName;
		//dropdown
		if (eleType === 'OPTION') {
			//clear all available-unavailable classes and disabled attribute
			val.classList.remove('available', 'unavailable');
			val.removeAttribute('disabled');
			if (availableValues.includes(val.getAttribute('data-attrvalue'))) {
				val.classList.add('available');
				val.removeAttribute('disabled');
			} else {
				val.classList.add('unavailable');
				val.setAttribute('disabled', 'disabled');
			}
			//swatches on desktop
			if(attrNameForEle === 'color' && $('.desktopPage').length > 0) {
				let swatchSelector = document.querySelectorAll('.swatchSpan');
				swatchSelector.forEach((swatch => {
					swatch.classList.remove('swatches-notAvailable');
					swatch.removeAttribute('disabled', 'disabled');
					let spanColor = swatch.getAttribute('data-spancolor');
					if(availableValues.includes(spanColor)) {
						swatch.classList.remove('swatches-notAvailable');
						swatch.removeAttribute('disabled', 'disabled');
					} else {
						swatch.classList.add('swatches-notAvailable');
						swatch.setAttribute('disabled', 'disabled');
					}
				}))
			}
			//Add price point
			let attrLength = Object.keys(priceObj).length;
			if (selectedAttrName !== attrName || attrName === 'Item' || attrLength === 1 || isOneOpt) {
				getPriceDisplayType(attrName, val, priceObj, selectedAttrName);
			}
			
		}
		//button
		if (eleType === 'LI') {
			//clear all available-unavailable classes and disabled attribute
			val.classList.remove('available', 'unavailable');
			val.removeAttribute('disabled');
			if (availableValues.includes(val.getAttribute('data-attrvalue'))) {
				val.classList.remove('DisabledFlatSize', 'unavailable');
				val.removeAttribute('disabled');
			} else {
				val.classList.add('DisabledFlatSize', 'unavailable');
				val.removeAttribute('disabled', 'disabled');
			}
			if (selectedAttrName !== attrName) {
				getPriceDisplayType(attrName, val, priceObj, selectedAttrName, availableValues);
			}
		}
	}))

}

function clearPrice(selectedAttrName) {
	selectedAttrName = selectedAttrName.replace(' ', '').toLowerCase();
	let selectedParent = '[data-attrname=' + selectedAttrName.toLowerCase() + ']';
	let selectOpts = document.querySelectorAll(selectedParent);
	selectOpts.forEach(option => {
		let optStr = option.innerHTML.split('-');
		let optStrVal = optStr[0].trim();
		option.innerHTML = optStrVal;
	})
}

function haveAllAttrsSelected() {
	let curAttrState = getAttrState();
	let totalAttrs = 0;
	let selectedAttrs = 0;
	Object.values(curAttrState).map((attr => {
		totalAttrs++;
		if (attr.selectedValue !== undefined) {
			selectedAttrs++;
		}
	}))
	if (totalAttrs === selectedAttrs) {
		return true;
	} else {
		return false;
	}
}

function getOneSkuPrice() {
	let curAttrState = getAttrState();
	let getDivSKUs = JSON.parse(document.getElementById('allSkus').innerText);
	const skuAllAttrVals = Object.values(getDivSKUs).filter(sku=>{
		return sku?.definingAttributes?.every(attribute =>{
			if(curAttrState[attribute.name]?.selectedValue && curAttrState[attribute.name]?.selectedValue != attribute.value.value){
				return false;
			}
			return true;
		})
	})
	let skuPrice;
	if(skuAllAttrVals.length > 0) {
		skuPrice = skuAllAttrVals.map((price => { return price.offer.price; }));
	}
	return skuPrice;
};

// save on select items: free shipping messaging (desktop only, not when iternational)
const freeShipping = (attrName) => {
	attrName = attrName.replace(' ', '').toLowerCase();
	let freeShipMsg = document.querySelector('#freeShippingMsg.saveOnSelect');
	if (freeShipMsg !== null) {
		let attrWithPricingStr = '.' + attrName + '-select';
		let attrWithPricing = document.querySelector(attrWithPricingStr);
		let attrWithPricingText = attrWithPricing.options[attrWithPricing.selectedIndex].text;
		let attrWithPricingPrice = attrWithPricingText.split('-');
		attrWithPricingPrice = attrWithPricingPrice[1];
		if(attrWithPricingPrice !== undefined) {
			attrWithPricingPrice = attrWithPricingPrice.replace('$', '');
			if (!isNaN(attrWithPricingPrice)) {
				if (attrWithPricingPrice >= 150) {
					freeShipMsg.style.display = 'block';
				} else {
					freeShipMsg.style.display = 'none';
				}
			}	
		}
	}
}

//If mobile, price changes at the top, if desktop or tablet, price shows in the dropdowns
function getPriceDisplayType(attrName, val, priceObj, selectedAttrName) {
	let oneSkuPrice;
	let allAttrsSelected = haveAllAttrsSelected();
	if ($('.mobilePage').length > 0) {
		if (allAttrsSelected) {
			oneSkuPrice = getOneSkuPrice();
			if(oneSkuPrice !== undefined) {
				flatSizeMobileQVPrice(oneSkuPrice);
			}
		}
	} else {
		addPrice(attrName, priceObj, val, selectedAttrName);
		if(allAttrsSelected) {
			freeShipping(attrName);
		}
	}
};

function addPrice(attrName, priceObj, val, isItem) {
	let curPriceVals = [];
	let curPriceValOneOpt = [];
	Object.keys(priceObj).map((aName => {
		if (aName === attrName) {
			Object.values(priceObj[aName]).map((val => {
				let attrVal = val.attrVal;
				let minPrice = val.minPrice;
				let maxPrice = val.maxPrice;
				let attrStr = { attrVal, minPrice, maxPrice };
				curPriceVals.push(attrStr)
			}))
		}
	}))
	if(attrName === 'Item' || isItem) {
		let itemVal = document.querySelectorAll('[data-attrname=item]');
		itemVal.forEach((val) => {
			let attrVal = val.getAttribute('data-attrvalue');
			let curVal = val.innerHTML;
			curPriceVals.map((pVal => {
				let curAttrVal = pVal.attrVal;
				let minPrice = pVal.minPrice;
				let maxPrice = pVal.maxPrice;
				if(curAttrVal === attrVal) {
					let curPriceStr = priceConvertComponent(minPrice, maxPrice);
					if (!curVal.includes('-')) {
						val.innerHTML = curVal + ' - ' + curPriceStr;
					}
				}
			}))
		})
	}
	if (val === 'oneOpt') {
		const notAllowedAttr = [attrName];
		const newPriceObj = Object.keys(priceObj).reduce((acc, key) => {
			if(!notAllowedAttr.includes(key)) {
				acc[key] = priceObj[key];
			}
			return acc;
		}, {});
		Object.keys(newPriceObj).map((aName => {
			Object.values(newPriceObj[aName]).map((val => {
				let attrVal = val.attrVal;
				let minPrice = val.minPrice;
				let maxPrice = val.maxPrice;
				let attrStr = { attrVal, minPrice, maxPrice };
				curPriceValOneOpt.push(attrStr)
			}))
		}))
		let otherAttr = Object.keys(newPriceObj);
		let oneOptSelect;
		Object.values(otherAttr).map((attr => {
			let attrNameNoSpace = attr.replace(' ', '');
			oneOptSelect = document.querySelectorAll('[data-attrname=' + attrNameNoSpace.toLowerCase() + ']');
			//only show price points on dropdowns
			if(oneOptSelect[0].nodeName !== 'LI') {
				oneOptSelect.forEach((val) => {
					let attrVal = val.getAttribute('data-attrvalue');
					let curVal = val.innerHTML;
					curPriceValOneOpt.map((pVal => {
						let curAttrVal = pVal.attrVal;
						let minPrice = pVal.minPrice;
						let maxPrice = pVal.maxPrice;
						if(curAttrVal === attrVal) {
							let curPriceStr = priceConvertComponent(minPrice, maxPrice);
							if (!curVal.includes('-')) {
								val.innerHTML = curVal + ' - ' + curPriceStr;
							}
						}
					}))
				})
			}
		}))			
	} else {
		if(val || val !== undefined) {
			let curPriceStr, curOptName, curOptVal, hasOneOption, curIsUnavailable, curVal;
			curOptVal = val.getAttribute('data-attrvalue');
			curOptName = val.getAttribute('data-attrname');
			hasOneOption = val.classList.contains('one-option');
			curIsUnavailable = val.classList.contains('unavailable');
			curPriceVals.map((price) => {
				if (price.attrVal === curOptVal && !hasOneOption && !curIsUnavailable) {
					curPriceStr = priceConvertComponent(price.minPrice, price.maxPrice);
					curVal = val.innerHTML;
					if (!curVal.includes('-')) {
						val.innerHTML = curVal + ' - ' + curPriceStr;
					}
				}
			})
		}
	}

}

function priceConvertComponent(priceOne, priceTwo) {
	let inputPriceOne = getPriceAsNumber(priceOne);
	let inputPriceTwo = getPriceAsNumber(priceTwo);
	let output_price_one = '';
	let output_price_two = '';
	if (!isNaN(inputPriceOne) && !isNaN(inputPriceTwo)) {
		output_price_one = priceConvert(inputPriceOne).toString();
		output_price_two = priceConvert(inputPriceTwo).toString();
	}
	const zonosIsWorking = typeof zonos === 'object' ? true : false;
	const displayPriceOne = zonosIsWorking ? zonos.currencyConvertAndFormat(output_price_one) : '$' + output_price_one;
	const displayPriceTwo = zonosIsWorking ? zonos.currencyConvertAndFormat(output_price_two) : '$' + output_price_two;
	const pricesMatch = displayPriceOne === displayPriceTwo;
	const priceString = pricesMatch ? displayPriceOne : displayPriceOne + ' - ' + displayPriceTwo;
	return priceString;
}

function getPriceAsNumber(priceIn) {
	let p;
	if (priceIn && typeof (priceIn) !== 'undefined' && !isNaN((priceIn + '').split('$').join('').split(',').join('').trim())) {
		p = (priceIn + '').split('$').join('').split(',').join('') * 1;
	}
	return p;
}

function priceConvert(priceIn) {
	return priceIn.toFixed(2);
}

function buildPriceObj() {
	let curAttrState = getAttrState();
	let allSkus = JSON.parse(document.getElementById('allSkus').innerText);
	//Get Prices based off of selected Values
	const skustoPrice = allSkus.filter((sku => {
		let hasAllAttrs = Object.keys(curAttrState).every((attrName => {
			let hasAllSelAttributes = true;
			sku.definingAttributes.forEach((attr => {
				if (curAttrState[attrName].selectedValue && attr.name === attrName && curAttrState[attrName].selectedValue !== attr.value.value) {
					hasAllSelAttributes = false;
				}
				return curAttrState[attrName].selectedValue !== attr.value.value;
			}))
			return hasAllSelAttributes;
		}))
		return hasAllAttrs;
	}))
	//Get prices of other skus that aren't in the selected values
	let priceRange = getPrice(skustoPrice);
	const otherSkus = allSkus.filter((sku => {
		let hasSomeAttrs = Object.keys(curAttrState).some((attrName => {
			let hasSomeAttributes = false;
			sku.definingAttributes.forEach((attr => {
				if (curAttrState[attrName].selectedValue && attr.name === attrName && curAttrState[attrName].selectedValue === attr.value.value) {
					hasSomeAttributes = true;
				}
				return curAttrState[attrName].selectedValue === attr.value.value
			}))
			return hasSomeAttributes;
		}))
		return hasSomeAttrs
	}))
	let allPrices = getPrice(otherSkus);
	let priceForDisp = {};
	Object.keys(allPrices).map((attrName => {
		if (!priceForDisp?.[attrName]) {
			priceForDisp[attrName] = {}
		}
		Object.keys(allPrices?.[attrName]).map((attrVal => {
			if (priceRange?.[attrName]?.[attrVal]) {
				priceForDisp[attrName][attrVal] = priceRange[attrName][attrVal];
			} else {
				priceForDisp[attrName][attrVal] = allPrices[attrName][attrVal];
			}
		}))
	}))
	return priceForDisp;
}

const getPrice = (skus) => {
	let priceObj = {};
	skus.forEach((sku => {
		sku.definingAttributes.forEach((defAttr => {
			let price = sku.offer.price;
			let attrName = defAttr.name;
			let attrVal = defAttr.value.value;
			if (priceObj[attrName]) {
				if (priceObj[attrName][attrVal]) {
					const currentMin = priceObj[attrName][attrVal].minPrice;
					const currentMax = priceObj[attrName][attrVal].maxPrice;
					if (price > currentMax) {
						priceObj[attrName][attrVal].maxPrice = price;
					}
					if (price < currentMin) {
						priceObj[attrName][attrVal].minPrice = price;
					}
				} else {
					priceObj[attrName][attrVal] = { attrVal, minPrice: price, maxPrice: price }
				}
			}
			else {
				priceObj[attrName] = {};
				priceObj[attrName][attrVal] = { attrVal, minPrice: price, maxPrice: price };
			}

		}))
	}))
	return priceObj;
}

function buttonAttrChange(selectedAttrName, selectedAttrVal, isOneOpt) {
	addSelectedClass(selectedAttrName, selectedAttrVal, 'button')
	//get current Attr State
	const curAttrState = getAttrState();
	
	Object.keys(curAttrState).map((attrName => {
		getAvailableSkus(attrName, selectedAttrName, selectedAttrVal);
	}))
}

function dropDownAttrChange(selectedAttrName, selectedAttrVal, isItem, isOneOpt) {
	addSelectedClass(selectedAttrName, selectedAttrVal);
	if (isItem === 'item') {
		let priceObj = buildPriceObj();
		addPrice('Item', priceObj);
	} else {
		const curAttrState = getAttrState();
		Object.keys(curAttrState).map((attrName => {
			getAvailableSkus(attrName, selectedAttrName, isOneOpt);
		}))
	}
}

export { getAttrState, getAllImages, altClickImages, buildMainSkuObj, getAttrDisplayStyle, getAttrValues, dropDownAttrChange, buttonAttrChange, getAttrLength, oneAttrPageLoad, dropDownOneAttrChange, buttonOneAttrChange, itemPageLoad, oneOptPageLoad };
